import { useEffect, useState } from 'react';
import { message } from 'antd';

export interface KnowledgePoint {
  entityUuid?: string;
  knowledgePointCnName?: string;
  knowledgePointCode?: string;
  knowledgePointFullPathCnName?: string[];
}

function useKnowledgePointSetting(contentUuid: string) {
  const [knowledgePoints, setKnowledgePoints] = useState<KnowledgePoint[]>([]);

  const fetchKnowledgePointSetting = () => {
    const url =
      alo7Api.prefix.host +
      `/api/v1/business_content_${
        alo7Nav.subject
      }/${contentUuid}/knowledge_points`;
    alo7Api
      .fetch(url)
      .then(res => {
        setKnowledgePoints(res);
      })
      .catch(err => message.error(err.message));
  };

  useEffect(() => {
    if (contentUuid) {
      fetchKnowledgePointSetting();
    }
  }, [contentUuid]);

  function handleKnowledgePointUpdate(knowledgePointCodes: string[]) {
    const url =
      alo7Api.prefix.host +
      `/api/v1/business_content_${
        alo7Nav.subject
      }/${contentUuid}/knowledge_points`;
    const updateKnows = {
      knowledgePointCodes,
    };
    alo7Api
      .fetch(url, {
        method: 'PUT',
        body: JSON.stringify(updateKnows),
      })
      .then(res => {
        message.success('保存成功');
        fetchKnowledgePointSetting();
      })
      .catch(err => message.error(err.message));
  }

  function removeKnowledgePoint(knowledgePointCode: string) {
    const url =
      alo7Api.prefix.host +
      `/api/v1/business_content_${
        alo7Nav.subject
      }/${contentUuid}/knowledge_point?knowledgePointCode=${knowledgePointCode}`;
    alo7Api
      .fetch(url, {
        method: 'DELETE',
      })
      .then(res => {
        message.success('删除成功');
        fetchKnowledgePointSetting();
      })
      .catch(err => message.error(err.message));
  }

  function handleKnowledgePointAutoUpdate(inIgnoreMsg: boolean = false) {
    const url =
      alo7Api.prefix.host +
      `/api/v1/business_content_${
        alo7Nav.subject
      }/${contentUuid}/knowledge_points_auto`;

    return alo7Api
      .fetch(url, { method: 'PUT' })
      .then(res => {
        !inIgnoreMsg && message.success('自动标记成功');
        fetchKnowledgePointSetting();
      })
      .catch(err => message.error(err.message));
  }

  return {
    setKnowledgePoints,
    knowledgePoints,
    handleKnowledgePointUpdate,
    handleKnowledgePointAutoUpdate,
    removeKnowledgePoint,
  };
}

export default useKnowledgePointSetting;
